export const filterSortingExceptions: string[] = [
  "DayOfWeek",
  "queryEfficiencyClassification",
  "queryObservationTypeId",
  "queryCpuUsageClassification",
  "queryIoUsageClassification",
  "queryExecutionTimeClassification",
  "effortTypeId",
  "queryOptimizationStatus",
  "queryAnnualCostRank",
  "queryCpuRank",
  "queryIoRank",
  "databaseSizeRange",
  "tableSizeRange",
  "tableRowCountRange",
];

export const filterSortingById: string[] = ["impactTypeId", "tableLastAccessCategoryType"];
